import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import globalValues from "../../../../../utilities/apiRequests/globalValues";



const MapLocationComponent = ({ lat, lng, height = "237px", borderRadius = "0px" }) => {
    const containerStyle = {
        width: "100%",
        height: height,
        borderRadius: borderRadius
    };
    const center = {
        lat: lat,
        lng: lng,
    };
    return (
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={18}>
            <Marker position={center} />
        </GoogleMap>
    );
};

export default MapLocationComponent;
